import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setModal } from "../../store/reducers/helpersReducer";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow, { tableRowClasses } from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Viewer from 'react-viewer';

import { styled } from '@mui/material/styles';
import { formarDate, statuses, translate } from "../controls/old/AccountingSheetTableControl";
import { $authHost } from "../../http";
import { useAuth } from "react-oidc-context";
import { useSelector } from "react-redux";


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const TabPanel = ({ children, value, index }) => {
    return value === index && <Box>{children}</Box>;
};

const materialMapping = {
    '1': 'Дерево',
    '2': 'Железобетон',
    '3': 'Сталь'
}

const StyledTableCellAccounting = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#CD5C5C',
        color: 'white',
        padding: '5px',
        fontSize: window.innerWidth < 768 ? 10 : 14,
        fontWeight: 'bold'
    },
    [`&.${tableCellClasses.body}`]: {
        padding: '5px',
        fontSize: window.innerWidth < 768 ? 10 : 14,
        lineHeight: 1
    },
}));

const StyledTableCellSpec = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#7E59CD',
        color: 'white',
        padding: '5px',
        fontSize: window.innerWidth < 768 ? 10 : 14,
        fontWeight: 'bold'
    },
    [`&.${tableCellClasses.body}`]: {
        padding: '5px',
        fontSize: window.innerWidth < 768 ? 10 : 14,
        lineHeight: 1
    },
}));

const StyledTableCellSpecCat = styled(TableCell)(({ theme }) => ({

    [`&.${tableCellClasses.body}`]: {
        padding: '5px',
        fontSize: window.innerWidth < 768 ? 10 : 14,
        fontWeight: 'bold',
        // backgroundColor: '#AB9AE0',
    },
}));

const StyledTableRowAccounting = styled(TableRow)(({ theme }) => ({

    '&:nth-of-type(even)': {
        backgroundColor: '#FFE4E1',
    },

}));

const StyledTableRowSpec = styled(TableRow)(({ theme }) => ({

    // '&:nth-of-type(even)': {
    //     backgroundColor: '#E7E3FF',
    // },

}));

const StyledTab = styled(Tab)(({ theme }) => ({
    '&': {
        fontSize: window.innerWidth < 768 ? 12 : 16,
    }

}));

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
    '&': {
        padding: window.innerWidth < 768 ? '3px 10px 5px' : '5px 20px 20px',
    }

}));

const ModalPillars = (props) => {
    const dispatch = useDispatch()
    const auth = useAuth()
    const mark = props.mark
    const [value, setValue] = useState(mark.accountings.length > 0 ? 0 : 1);
    const [images, setImages] = useState([]);
    const [visible, setVisible] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [spec, setSpec] = useState(null)
    const { specs } = useSelector(state => state.state)
    const handleClose = () => {
        dispatch(setModal(null))
    };

    const types = {
        'pillar04': 'Опора 0,4кВ',
        'pillar04_10': 'Опора 0,4-10кВ',
        'pillar10': 'Опора 10кВ',
        
    }

    useEffect(() => {
        $authHost.get(`/apig/state/pillars/images_list?tpid=${mark.tp_id}&pillarid=${mark.fid}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(`oidc.user:${auth.settings.authority}:${auth.settings.client_id}`) ? JSON.parse(localStorage.getItem(`oidc.user:${auth.settings.authority}:${auth.settings.client_id}`))?.access_token : null}`
            }
        }).then(res => {
            if (res) setImages(res.data)

        })
    }, [])

    useEffect(() => {
        if (specs) {
            setSpec(specs.pillars.find(s => s.id === mark.spec.id))
        }
    }, [specs])



    return (
        <Dialog
            open={true}
            Transition={Transition}
            keepMounted
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
            maxWidth={'lg'}
            scroll="paper"
            fullScreen={window.innerWidth < 768 ? true : false}



        >
            <DialogTitle align="center" style={{ padding: '10px 50px', fontSize: window.innerWidth < 768 ? 16 : 24 }} >{types[mark.tags.type]}: {props.prefix ? props.prefix : ''}{mark.name}</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon />
            </IconButton>
            <StyledDialogContent>
                <Box>
                    <Tabs
                        value={value}
                        onChange={(_event, newValue) => setValue(newValue)}
                        textColor="primary"
                        indicatorColor="primary"
                        aria-label="primary tabs"
                        style={{ minHeight: '0', marginBottom: '5px' }}
                        variant="scrollable"
                        scrollButtons="auto"
                    >
                        {mark.accountings.length > 0 ? <StyledTab value={0} label="Предписания" style={{ minHeight: '0', padding: '4px 8px' }} /> : null}
                        <StyledTab value={1} label="Спецификация" style={{ minHeight: '0', padding: '4px 8px' }} />
                        {/* <StyledTab value={2} label="История" style={{ minHeight: '0', padding: '4px 8px' }} /> */}
                        {images.length > 0 ? <StyledTab value={3} label="Фотоальбом" style={{ minHeight: '0', padding: '4px 8px' }} /> : null}
                    </Tabs>

                </Box>
                <TabPanel key={0} value={value} index={0}>
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <StyledTableRowAccounting>
                                    <StyledTableCellAccounting align="center">№</StyledTableCellAccounting>
                                    <StyledTableCellAccounting align="center">Выявленные отступления от ПСД</StyledTableCellAccounting>
                                    <StyledTableCellAccounting align="center">Указания и сроки их выполнения</StyledTableCellAccounting>
                                    <StyledTableCellAccounting align="center">Отметка о выполнении</StyledTableCellAccounting>
                                    {/* <th>Создано</th> */}
                                    <StyledTableCellAccounting align="center">Авторский надзор</StyledTableCellAccounting>
                                </StyledTableRowAccounting>
                            </TableHead>
                            <TableBody>
                                {
                                    mark.accountings.map((acc, i) => {
                                        let status = null
                                        if (acc.status && Object.keys(translate).includes(acc.status)) {
                                            status = statuses[translate[acc.status]]
                                        }
                                        if (!status) return null
                                        let color = status.color
                                        let icon = status.icon
                                        return (
                                            <StyledTableRowAccounting key={i}>
                                                <StyledTableCellAccounting style={{ textAlign: 'center' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                        <svg width={10} height={10} viewBox="0 0 100 100" style={{ margin: '5px 0' }}>
                                                            <circle r="50" cx="50" cy="50" fill={color} />
                                                        </svg>
                                                        <span style={{ verticalAlign: 'middle' }}>{acc.id}</span>
                                                    </div>
                                                </StyledTableCellAccounting>
                                                <StyledTableCellAccounting>{acc.retreat_psd}</StyledTableCellAccounting>
                                                <StyledTableCellAccounting>
                                                    <span style={{ color: color }}>{acc.instructions}</span>
                                                </StyledTableCellAccounting>
                                                <StyledTableCellAccounting style={{ color: color, textAlign: 'center' }}>
                                                    <div>
                                                        <span className="material-icons" style={{ margin: '0px 5px' }}>{icon}</span>
                                                        <span style={{ verticalAlign: 'middle' }}>{status.text}</span>
                                                    </div>
                                                    <div>
                                                        <span className="material-icons" style={{ margin: '0px 5px' }}>event</span>
                                                        <span style={{ verticalAlign: 'middle' }}>{formarDate(acc.edited)}</span>
                                                    </div>
                                                    <div>
                                                        <span className="material-icons" style={{ margin: '0px 5px' }}>engineering</span>
                                                        <span style={{ verticalAlign: 'middle' }}>{acc.editor}</span>
                                                    </div>


                                                </StyledTableCellAccounting>
                                                {/* <td style={{ color: 'var(--color-created)', textAlign: 'center' }}>

                                                                        </td> */}
                                                <StyledTableCellAccounting style={{ color: 'var(--color-created)', textAlign: 'center' }}>
                                                    <div>
                                                        <span className="material-icons" style={{ margin: '2px 5px' }}>event</span>
                                                        <span style={{ verticalAlign: 'middle' }}>{acc.created}</span>
                                                    </div>
                                                    <div>
                                                        <span className="material-icons" style={{ margin: '2px 5px' }}>engineering</span>
                                                        <span style={{ verticalAlign: 'middle' }}>{acc.creator}</span>
                                                    </div>

                                                </StyledTableCellAccounting>
                                            </StyledTableRowAccounting>
                                        )

                                    })
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>

                </TabPanel>
                <TabPanel key={1} value={value} index={1}>
                    <div key={'desct'} style={{ display: 'flex', flexDirection: 'column', fontSize: window.innerWidth < 768 ? 10 : 14 }}>
                        <span key={1}><b>Наименование:</b> {mark.spec.name}</span>
                        <span key={2}><b>Тип, марка, обозначение документа, опросного листа:</b> {mark.spec.type_marka_docs}</span>
                        <span key={3}><b>Категория:</b> {mark.spec.category}</span>
                        <span key={4}><b>Материал:</b> {materialMapping[mark.spec.material_type]}</span>
                        <span key={5}><b>Количество опор:</b> {mark.spec.supports_count}</span>
                    </div>
                    <TableContainer key={'table'} component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <StyledTableRowSpec>
                                    <StyledTableCellSpec align="center">Наименование</StyledTableCellSpec>
                                    <StyledTableCellSpec align="center">Тип, марка, обозначение документа, опросного листа</StyledTableCellSpec>
                                    <StyledTableCellSpec align="center">Завод изготовитель</StyledTableCellSpec>
                                    <StyledTableCellSpec align="center">Количество</StyledTableCellSpec>
                                    <StyledTableCellSpec align="center">Масса ед., кг.</StyledTableCellSpec>
                                </StyledTableRowSpec>
                            </TableHead>
                            <TableBody>
                                {
                                    mark.spec.complect_filtered.map(cf => {
                                        return (
                                            [{ type: cf.type }, ...cf.compl].map((c, i) => {
                                                if (i === 0) {
                                                    return (
                                                        <StyledTableRowSpec key={i}>
                                                            <StyledTableCellSpecCat colSpan={5} align="center" style={{ fontWeight: 'bold' }}>{c.type}</StyledTableCellSpecCat>

                                                        </StyledTableRowSpec>
                                                    )
                                                }
                                                return (
                                                    <StyledTableRowSpec key={i}>
                                                        <StyledTableCellSpec>{c.name}</StyledTableCellSpec>
                                                        <StyledTableCellSpec>{c.type_marka_docs}</StyledTableCellSpec>
                                                        <StyledTableCellSpec>{c.factory_manufacturer}</StyledTableCellSpec>
                                                        <StyledTableCellSpec>{parseInt(c.count)} {c.unit}.</StyledTableCellSpec>
                                                        <StyledTableCellSpec>{parseFloat(c.massa_1ed_kg) * parseFloat(c.count)}</StyledTableCellSpec>
                                                    </StyledTableRowSpec>
                                                )
                                            })

                                        )
                                    })
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>

                </TabPanel>
                <TabPanel key={2} value={value} index={2}>
                    В разработке
                </TabPanel>
                <TabPanel key={3} value={value} index={3}>
                    <ImageList cols={3} rowHeight={250}>
                        {images.map((image, i) => {
                            return (
                                <ImageListItem key={image['d:propstat']['d:prop']['oc:fileid']}>
                                    <img
                                        key={i}
                                        src={`http://gis.komoks.ru/apig/share/image_preview?id=${image['d:propstat']['d:prop']['oc:fileid']}`}
                                        alt={image['d:propstat']['d:prop']['d:displayname']}
                                        loading="lazy"
                                        onClick={() => {
                                            setActiveIndex(i);
                                            setVisible(true);
                                        }}
                                    />
                                    <ImageListItemBar
                                        title={image['d:propstat']['d:prop']['d:displayname']}
                                        subtitle={image['d:propstat']['d:prop']['os:size']}
                                    />
                                </ImageListItem>
                            )
                        })}
                    </ImageList>
                    <Viewer
                        visible={visible}
                        onClose={() => setVisible(false)}
                        images={images.map(image => ({
                            src: `http://gis.komoks.ru/apig/share/image_full?tpid=${mark.tp_id}&pillarid=${mark.fid}&imageid=${image['d:propstat']['d:prop']['oc:fileid']}`,
                            alt: image['d:propstat']['d:prop']['d:displayname']
                        }))}
                        activeIndex={activeIndex}
                        zIndex={9999}
                        downloadable={true}
                        scalable={true}
                        rotatable={true}
                        zoomable={true}
                        drag={true}
                    />
                </TabPanel>
            </StyledDialogContent >
        </Dialog >
    )


}
export default ModalPillars